import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';
import type { EvaluationDraft } from '@recruitee/evaluations-types';

const STORAGE_KEY_PREFIX = 'evaluation-panel-draft';

@Injectable({ providedIn: 'root' })
export class EvaluationDraftService {
  private readonly localStorage = inject(LocalStorageService);

  public getDraft(candidateId: number): EvaluationDraft | null {
    const draft = this.localStorage.get(this.storageKey(candidateId), null);

    return this.isDraft(draft) ? draft : null;
  }

  public saveDraft(draft: EvaluationDraft): void {
    void this.localStorage.set(this.storageKey(draft.data.candidateId), draft);
  }

  public clearDraft(candidateId: number): void {
    this.localStorage.remove(this.storageKey(candidateId));
  }

  private storageKey(candidateId: number): string {
    return `${STORAGE_KEY_PREFIX}-${candidateId}`;
  }

  private isDraft(value: unknown): value is EvaluationDraft {
    return (
      !!value &&
      typeof value === 'object' &&
      'data' in value &&
      'form' in value &&
      typeof (<EvaluationDraft>value).data?.candidateId === 'number'
    );
  }
}
